import { createApp } from './entry-common';

const { app, router, store } = createApp();

if ((window as any).__INITIAL_STATE__) {
    store.replaceState((window as any).__INITIAL_STATE__);
}

app.$mount('#app')

